import { toast } from 'react-toastify'
import { stringToUUID } from './hashing'

// A simple wrapper around the toast library to make it easier to adapt in the future.
export class ToastManager {
  static error(message, options) {
    if (!message) return

    const toastId = stringToUUID(message)
    if (toast.isActive(toastId)) {
      return
    }

    const toastOptions = {
      ...(options || {}),
      toastId: toastId,
    }
    toast.error(message, toastOptions)
  }

  static success(message, options) {
    if (!message) return

    const toastId = stringToUUID(message)
    if (toast.isActive(toastId)) {
      return
    }

    const toastOptions = {
      ...(options || {}),
      toastId: toastId,
    }
    toast.success(message, toastOptions)
  }

  static info(message, options) {
    if (!message) return

    const toastId = stringToUUID(message)
    if (toast.isActive(toastId)) {
      return
    }

    const toastOptions = {
      ...(options || {}),
      toastId: toastId,
    }
    toast.info(message, toastOptions)
  }
}
